// extracted by mini-css-extract-plugin
module.exports = {"banner":"banner_1pAHl","contentWrapper":"contentWrapper_3W9G1","link":"link_3ryZL","button":"button_2SQF8"};